module.exports = __webpack_public_path__ + "10e1b7a4c745662b07039ad2689fd27d.pdf";